var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.35498,
    width: 3.78855,
    height: 3.81208,
    fill: "current"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 6.91821,
    y: 0.35498,
    width: 3.78855,
    height: 3.81208,
    fill: "current"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 13.8364,
    y: 0.35498,
    width: 3.78855,
    height: 3.81208,
    fill: "current"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    y: 7.66162,
    width: 3.78855,
    height: 3.81208,
    fill: "current"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 6.91821,
    y: 7.66162,
    width: 3.78855,
    height: 3.81208,
    fill: "current"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 13.8364,
    y: 7.66162,
    width: 3.78855,
    height: 3.81208,
    fill: "current"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    y: 14.3325,
    width: 3.78855,
    height: 3.81208,
    fill: "current"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 6.91821,
    y: 14.3325,
    width: 3.78855,
    height: 3.81208,
    fill: "current"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 13.8364,
    y: 14.3325,
    width: 3.78855,
    height: 3.81208,
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconList);
export default __webpack_public_path__ + "static/media/icon-list.f565a7c8.svg";
export { ForwardRef as ReactComponent };